// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    useSelector,
} from 'react-redux'

// components
import {
    LinkHelperSite,
} from 'components'

// data
import {
    defaultReduxState,
} from 'data'

// serializers
import {
    LearContentHelperSerializer,
} from 'serializers/site'

// props
type LearnSideMenuTabSiteProps = {
    learnPageSlug: string
    object: LearContentHelperSerializer
}

// main
export const LearnSideMenuTabSite: React.FC<LearnSideMenuTabSiteProps> = React.memo(({
    learnPageSlug,
    object,
}) => {

    const reduxCacheSiteportfolioid = useSelector((state: defaultReduxState) => state.reduxCacheSite.portfolio?.id)
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    const deviceType = reduxModalSite.deviceType

    const [isCollapsed, setIsCollapsed] = useState<boolean>()
    // const [isCollapsed, setIsCollapsed] = useState<boolean>((tabSlug !== object.slug) && (tabSlug?.split('-')[0] !== object.slug))

    // useEffect(() => {
    //     let shoulCollapse = (tabSlug !== object.slug) && (tabSlug?.split('-')[0] !== object.slug)
    //     if (shoulCollapse) {
    //         object.children?.map(val => {
    //             if (val.slug === tabSlug) shoulCollapse = false
    //         })
    //     }
    //     if (isCollapsed && !shoulCollapse) {
    //         setIsCollapsed(shoulCollapse)
    //     }
    // }, [
    //     tabSlug,
    // ])

    return (
        <div className={`learn-side-menu-tab-site ${deviceType}`}>
            <div className={`lsmts-tab-item-wrap ${deviceType}`}>
                <i
                    className={`lsmts-expand mo-new-icon-caret-right-solid${isCollapsed ? '' : ' open'}${object.children?.length! > 0 ? '' : ' hidden'} ${deviceType}`}
                    onClick={() => setIsCollapsed(!isCollapsed)}
                />
                <LinkHelperSite
                    action='generic_link'
                    className={`lsmts-tab-item ${learnPageSlug} ${deviceType} p-${reduxCacheSiteportfolioid}`}
                    to={object.get_absolute_url}
                    onClick={() => undefined}
                >
                    {object.name}
                </LinkHelperSite>
                <i className={`lsmts-completed mo-new-icon-check-circle-solid${object.is_completed ? ' done' : ''} ${deviceType}`} />
            </div>
            {object.children?.length! > 0 && (
                <div className={`lsmts-children-wrap${isCollapsed ? '' : ' open'} ${deviceType}`}>
                    {object.children?.map((val) => (
                        <LearnSideMenuTabSite
                            key={val.id}
                            learnPageSlug={learnPageSlug}
                            object={val}
                        />
                    ))}
                </div>
            )}
        </div>
    )
})
